/**
 * Классы раскладки строки управления списком диалогов: три блока («Действия», переключатели
 * поиска по содержимому, управление пресетами) и раскрываемые ими подстроки.
 *
 * Ступени считаются по ширине самой строки, а не окна: список делит ширину с детализацией
 * диалога, поэтому строке тесно и на широком экране.
 */
export const CONTROL_ROW_CLASS = 'flex flex-wrap items-center gap-x-3 gap-y-2';

/** Общая высота блоков: разное наполнение не должно давать разную высоту. */
export const CONTROL_BLOCK_HEIGHT_CLASS = 'flex min-h-9 items-center';

/**
 * Пресеты выносятся на свою строку первыми — они шире остальных блоков и ни с чем не связаны
 * одним жестом. В общей строке блок растёт из нулевого базиса: иначе длинное название пресета
 * уносило бы его на строку раньше своей ступени и вниз, а не вверх.
 *
 * Нижняя граница ширины в общей строке — про кнопки блока, а не про название: кнопки-иконки не
 * сжимаются, и блок, ужатый соседями уже их суммы, не обрезал бы их, а выпускал за свой край —
 * кнопки накрывали бы друг друга, и клик уходил бы в соседнюю. Не поместившись в границу, блок
 * целиком уходит на свою строку, где места хватает и на название слоя.
 */
export const PRESETS_BLOCK_CLASS =
  'order-1 w-full min-w-0 @4xl/dialogs-control:order-3 @4xl/dialogs-control:ml-auto @4xl/dialogs-control:w-auto @4xl/dialogs-control:flex-1 @4xl/dialogs-control:min-w-64 @4xl/dialogs-control:max-w-1/2 @4xl/dialogs-control:justify-end';

/** Плашка активного пресета шире значка на внутренний отступ кнопки — без сдвига блок выступает левее соседних. */
export const PRESETS_PLATED_START_CLASS = 'pl-2.5';

/**
 * Запас ширины под самое длинное сохранённое название существует ради соседей по строке: без него
 * переключение пресета двигало бы переключатели поиска. На своей строке двигать нечего, и запас
 * только растягивал бы кнопку во всю ширину — там ширину задаёт название активного пресета.
 */
export const PRESETS_WIDTH_RESERVE_CLASS = 'hidden @4xl/dialogs-control:block';

/**
 * Отступ постоянный, а не снимаемый на ступени общей строки: строку начинает то «Действия», то
 * сами переключатели — без разрешения на массовый запуск кнопки «Действия» нет.
 *
 * Перенос внутри блока разрешён на любой ширине, но включается сам собой — только когда места
 * блоку не хватает: строка сначала уносит блок целиком на свою строку и лишь потом сжимает его.
 * Привязать перенос к ширине окна нельзя: строке тесно и на промежуточной ширине окна
 * (закреплённая навигация, открытая карточка диалога), а без переноса крайний режим уходит
 * за край экрана недоступным.
 */
export const SEARCH_TOGGLES_BLOCK_CLASS =
  'order-2 w-full min-w-0 flex-row flex-wrap gap-1.5 whitespace-nowrap pl-2.5 @xl/dialogs-control:order-3 @xl/dialogs-control:w-auto @4xl/dialogs-control:order-2';

/** Подстрока, раскрываемая переключателями поиска. */
export const SEARCH_EXPANDED_BLOCK_CLASS = 'order-3 w-full min-w-0 @xl/dialogs-control:order-4';

/** «Действия» уходят на свою строку последними — вместе с переключателями поиска они применяются к одному списку */
export const ACTIONS_BLOCK_CLASS =
  'order-4 w-full min-w-0 @xl/dialogs-control:order-2 @xl/dialogs-control:w-auto @4xl/dialogs-control:order-1';

/** Подстрока, раскрываемая «Действиями». */
export const ACTIONS_EXPANDED_BLOCK_CLASS = 'order-5 w-full min-w-0';
